import React from 'react';
import { connect } from 'react-redux';
import { Button, Checkbox, Dropdown, Grid, Input, Select } from 'semantic-ui-react';
import SelectOperator from '../shared/SelectOperator';
import DownloadButton from '../shared/DownloadButton';

class EGMFilters extends React.Component {

  state = {
    statusOpen: false
  };

  handleSelection = (event, { name, value }) => this.props.onChange(name, value)

  handleStatusClick = (value) => {
    let selectedStatus = [...this.props.searchParams.selectedStatus];
    
    if (selectedStatus.includes(value)) {
      selectedStatus = selectedStatus.filter(x => x !== value)
    } else {
      selectedStatus.push(value)
    }

    this.props.onChange("selectedStatus", selectedStatus)
  }

  getSelect = (selectedKey, arrayKey) => {
    const disabled = !this.props.searchParams.selectedOperator;
    return <Select disabled={disabled} options={this.props.filters[arrayKey]} value={this.props.searchParams[selectedKey]} name={selectedKey} onChange={this.handleSelection} fluid />
  }

  render() {

    const disabled = !this.props.searchParams.selectedOperator || this.props.loading || false;

    return (
      <Grid columns="4" id="EGMFilters">
        <Grid.Row>
          <Grid.Column width="3" verticalAlign="middle">Operator</Grid.Column>
          <Grid.Column width="5" verticalAlign="middle">
            <SelectOperator fluid operators={this.props.operators} value={this.props.searchParams.selectedOperator} name="selectedOperator" onChange={this.props.onOperatorChange} />
          </Grid.Column>
          <Grid.Column width="3" verticalAlign="middle">Category</Grid.Column>
          <Grid.Column width="5" verticalAlign="middle">{ this.getSelect("selectedCategory", "categories") }</Grid.Column> 
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width="3" verticalAlign="middle">Depot</Grid.Column>
          <Grid.Column width="5" verticalAlign="middle">{ this.getSelect("selectedDepot", "depots") }</Grid.Column> 
          <Grid.Column width="3" verticalAlign="middle">Manufacturer</Grid.Column>
          <Grid.Column width="5" verticalAlign="middle">{ this.getSelect("selectedManufacturer", "manufacturers") }</Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width="3" verticalAlign="middle">Asset - Status</Grid.Column>
          <Grid.Column width="5" verticalAlign="middle">
            <Dropdown closeOnChange={false} item selection fluid id="status" text={ disabled ? "" : `${this.props.searchParams.selectedStatus.length} selected`} disabled={disabled}>
              <Dropdown.Menu>
                {this.props.filters.statuses.map(({ value, text }) => (
                  <Dropdown.Item key={value} onClick={(e) => {  e.stopPropagation(); e.preventDefault(); this.handleStatusClick(value) }}>
                    <Checkbox checked={this.props.searchParams.selectedStatus.includes(value)} disabled className="clickable mr-1" /> {text}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </Grid.Column>
          <Grid.Column width="3" verticalAlign="middle">Game Title/Pack</Grid.Column>
          <Grid.Column width="5" verticalAlign="middle">{ this.getSelect("selectedGameTitle", "gameTitles") }</Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width="3" verticalAlign="middle">Group By</Grid.Column>
          <Grid.Column width="5" verticalAlign="middle">{ this.getSelect("selectedGrouping", "groupings") }</Grid.Column>              
          <Grid.Column width="3" verticalAlign="middle">Cabinet Type</Grid.Column>
          <Grid.Column width="5" verticalAlign="middle">{ this.getSelect("selectedCabinetType", "cabinetTypes") }</Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width="3" verticalAlign="middle">Search</Grid.Column>
          <Grid.Column width="5" verticalAlign="middle"><Input fluid name="searchText" onChange={this.handleSelection} /></Grid.Column>  
          <Grid.Column width="3" verticalAlign="middle">Note Acceptor</Grid.Column>
          <Grid.Column width="5" verticalAlign="middle">{ this.getSelect("selectedNoteAcceptorModel", "noteAcceptorModels") }</Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width="3" verticalAlign="middle">
          </Grid.Column>
          <Grid.Column width="5" verticalAlign="middle" style={{ padding: "0em 0.5em"}}>
            <Button disabled={disabled} loading={this.props.loading || false} style={{ padding: "0.43em 1em"}} onClick={this.props.onRefresh} positive size="small">Refresh</Button>
            <DownloadButton disabled={this.props.disableDownload} onClick={this.props.onDownloadClick} caption="Export" style={{ padding: "0.43em 1em" }} />
          </Grid.Column>
          <Grid.Column width="3" verticalAlign="middle">Asset - Variant</Grid.Column>
          <Grid.Column width="5" verticalAlign="middle">{ this.getSelect("selectedVariant", "variants") }</Grid.Column>
        </Grid.Row>           
      </Grid>
    );
  }
};


const mapStateToProps = state => {
	return {
    operators: state.operators.filter(x => x.value !== -1),
  };
};

export default connect(mapStateToProps, {})(EGMFilters);
